/**************************************************
 * Nombre:       Formulario_Config_Crm
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {LocalOfferOutlined, ViewColumnOutlined} from "@mui/icons-material";
import {useState} from "react";
import IngresoTextoLista from "../../Modulo_formularios/Componentes/IngresoTextoLista";

const Formulario_Config_Crm = ({...props}) => {
    const [tipo, setTipo] = useState('Azul');


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoTextoLista Icono={ViewColumnOutlined} nombre={'Columnas'} dato={'columnas'} {...props}
                                       requerido={'Campo Requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoTextoLista Icono={LocalOfferOutlined} nombre={'Etiquetas'} dato={'etiquetas'} {...props}

                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Config_Crm